import { createFileRoute } from "@tanstack/react-router";
import HomeEs from "@/pages/es/HomeEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es`;
const EN_URL = SITE_URL;

export const Route = createFileRoute("/es/")({
  head: () => ({
    meta: [
      { title: "SAINT® TMS en Coral Springs | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "SAINT® TMS acelerada, guiada por fMRI y autorizada por la FDA para la depresión resistente al tratamiento. Proveedor verificado en Coral Springs, FL..",
      },
      {
        property: "og:title",
        content: "SAINT® TMS en Coral Springs | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "SAINT® TMS acelerada, guiada por fMRI y autorizada por la FDA para la depresión resistente al tratamiento. Proveedor verificado en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "SAINT® TMS Coral Springs | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content:
          "SAINT® TMS acelerada, guiada por fMRI y autorizada por la FDA para la depresión resistente al tratamiento. Proveedor verificado en Coral Springs, FL.",
      },
    ],
    links: [{ rel: "canonical", href: ES_URL }, ...buildHreflang("/")],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <HomeEs />;
}
